<template>
  <div class="position-sticky">
    <div v-if="!props.checkDates">
      <div class="card-image" v-if="!props.session  && !props.small">
        <div class="d-flex align-items-center justify-content-center">
          <div style="position: absolute;" class="font-weight-bold d-flex">
            <div class="course-shadow"></div>
            <img v-if="props.object.thumbnail"
                 :src="props.object.thumbnail"
                 class="cover-fit w-85px h-85px rounded-circle" alt="">
            <img v-else
                 class="cover-fit w-85px h-85px rounded-circle" alt=""
                 :src="NoThumbnail">
            <div v-if="!props.locked" class="progress_text">
              <span class="font-weight-bold">{{ getProgress(props.object.progress) }}</span>%
            </div>
            <div v-else style="z-index: 1; background: rgba(0, 0, 0, 0.7);"
                 class="position-absolute h-100 w-100
                 rounded-circle d-flex align-items-center justify-content-center">
              <img :src="IconLock"
                   class="lock" alt="">
            </div>
          </div>
          <svg class="donut donut__course donut__progress_course" viewBox="0 0 32 32">
            <circle class="donut__strokebackground_course"
                    cx="16" cy="16" r="14"></circle>
            <transition name="progress">
              <circle :key="props.object.progress"
                      class="donut__value donut__value__course" cx="16" cy="16" r="14"
                      :stroke-dashoffset="getDonutValue(props.object.progress)"></circle>
            </transition>
          </svg>
        </div>
      </div>
      <div v-else>
        <div class="d-flex align-items-center justify-content-center" style="margin-top: 0px">
          <div style="position: absolute; z-index: 1; font-size: 12px" class="font-weight-bold">
            {{ getProgress(props.object.progress) }}%</div>
          <svg class="donut donut__progress" viewBox="0 0 32 32">
            <circle class="donut__background" cx="16" cy="16" r="12"></circle>
            <circle class="donut__strokebackground" cx="16" cy="16" r="14"></circle>
            <transition name="progress">
              <circle :key="props.object.progress"
                    class="donut__value" cx="16" cy="16" r="14"
                    :stroke-dashoffset="getDonutValue(props.object.progress)"></circle>
            </transition>
          </svg>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="d-flex align-items-center justify-content-center progress-value display-h5">
        <div v-if="isSessionAvailable">
          <div v-if="!props.session && !props.small" class="card-image">
            <div class="rounded-circle position-relative">
              <div class="course-shadow"></div>
              <img class="cover-fit w-90px h-90px rounded-circle"
                   v-if="props.object.thumbnail"
                   :src="props.object.thumbnail"
                   alt="">
              <img class="cover-fit w-90px h-90px"
                   v-else
                   :src="defaultThumbnail" alt="">
              <div v-if="!props.locked" class="progress_text">
                <span class="font-weight-bold">{{ getProgress(props.object.progress) }}</span>%
              </div>
              <div v-else style="z-index: 1; background: rgba(0, 0, 0, 0.7);"
                   class="position-absolute h-100 w-100
               rounded-circle d-flex align-items-center justify-content-center">
                <img :src="IconLock"
                     class="lock" alt="">
              </div>
            </div>
          </div>
          <div v-else>
            <div class="d-flex align-items-center justify-content-center"
                 style="margin-top: -25px">
              <div style="position: absolute; z-index: 1; font-size: 12px"
                   class="font-weight-bold">
                {{ getProgress(props.object.progress) }}%</div>
              <svg class="donut donut__progress" viewBox="0 0 32 32">
                <circle class="donut__background" cx="16" cy="16" r="12"></circle>
                <circle class="donut__strokebackground" cx="16" cy="16" r="14"></circle>
                <transition name="progress">
                  <circle :key="props.object.progress"
                          class="donut__value" cx="16" cy="16" r="14"
                          :stroke-dashoffset="getDonutValue(props.object.progress)"></circle>
                </transition>
              </svg>
            </div>
          </div>
        </div>
        <div v-else class="d-flex align-items-center justify-content-center"
             style="margin-top: -15px">
          <div style="position: absolute; z-index: 1; font-size: 12px"
               class="font-weight-bold">
            <img :src="IconLock"
                 class="lock" alt=""></div>
          <svg class="donut donut__progress" viewBox="0 0 32 32">
            <circle class="donut__background" cx="16" cy="16" r="12"></circle>
            <circle class="donut__strokebackground" cx="16" cy="16" r="14"></circle>
            <transition name="progress">
              <circle :key="props.object.progress"
                      class="donut__value" cx="16" cy="16" r="14"
                      :stroke-dashoffset="getDonutValue(props.object.progress)"></circle>
            </transition>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useHelper } from '@/composables/useHelper';
import IconLock from '@/assets/images/icons/Icon_Lock.svg';
import NoThumbnail from '@/assets/images/no_thumbnail.png';

const props = defineProps({
  object: {
    type: Object,
    default: () => ({}),
  },
  checkDates: {
    default: true,
    type: Boolean,
  },
  small: {
    default: false,
    type: Boolean,
  },
  overlay: {
    default: false,
    type: Boolean,
  },
  session: {
    default: false,
    type: Boolean,
  },
  orgId: {
    default: '-1',
    type: String,
  },
  locked: {
    default: false,
    type: Boolean,
  },
});

const { isInferiorToToday } = useHelper();

const defaultThumbnail = NoThumbnail;
const isSessionAvailable = computed(() => (
  isInferiorToToday(props.object.start_date) && !isInferiorToToday(props.object.due_date)
));

const getDonutValue = (progress) => {
  const progressValue = Number(progress ?? 0);
  return ((progressValue / 100) * 90 + 90);
};

const getProgress = (progress) => {
  return Number(progress ?? 0);
};
</script>
<style scoped>
.lock{
  width: 2rem;
  height: 2rem;
}
</style>
